import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { USER_ROLE_ADMIN, USER_ROLE_AGENT } from "core/useSession";

import { LogoutIcon, PersonIcon } from "../../Icons/Icons";
import { MenuItemsRenderer } from "./MenuItemsRenderer";
import { UserInfo } from "./UserInfo";

/**
 * Component for rendering the expanded menu content
 */
const ExpandedMenuContent = ({
  menuConfig,
  membersMenuItem,
  pathname,
  handleNavigate,
  calculateIsModuleAllowed,
  calculateIsSubMenuOpen,
  toggleIsSubMenuOpen,
  globalState,
  activeProducer,
  myUser,
  activeAgent,
  handleActiveUserSignoutClick,
  handleLogoutClick,
}) => {
  return (
    <>
      <MenuItemsRenderer
        config={menuConfig}
        membersItem={null}
        pathname={pathname}
        handleNavigate={handleNavigate}
        calculateIsModuleAllowed={calculateIsModuleAllowed}
        calculateIsSubMenuOpen={calculateIsSubMenuOpen}
        toggleIsSubMenuOpen={toggleIsSubMenuOpen}
        globalState={globalState}
      />
      {(([USER_ROLE_ADMIN, USER_ROLE_AGENT].includes(globalState.user_role) && !globalState.is_broker) ||
        Boolean(activeProducer?.producer_token)) && <Divider />}

      <List>
        {membersMenuItem && membersMenuItem.condition(globalState) && (
          <ListItemButton
            sx={{
              height: "48px",
              color: pathname === membersMenuItem.path ? "secondary.main" : "inherit",
              borderRightStyle: "solid",
              borderRightWidth: "6px",
              borderRightColor: pathname === membersMenuItem.path ? "secondary.main" : "transparent",
              pl: 1.5,
            }}
            className={pathname === membersMenuItem.path ? "active" : ""}
            onClick={() => handleNavigate(membersMenuItem.path)}
          >
            <ListItemIcon sx={{ mr: 1, minWidth: 32 }}>
              <membersMenuItem.icon color={pathname === membersMenuItem.path && "secondary"} />
            </ListItemIcon>
            <ListItemText primary={membersMenuItem.text} />
          </ListItemButton>
        )}
        {Boolean(activeProducer?.producer_token) && (
          <>
            <Stack direction="row" alignItems="center" sx={{ ml: 1.5, my: 1, mr: "14px", minHeight: "48px" }}>
              <ListItemIcon sx={{ mr: 1, minWidth: 32 }}>
                <PersonIcon />
              </ListItemIcon>
              <Box>
                <Typography variant="caption">Viewing Account</Typography>
                <Typography variant="body1" sx={{ textTransform: "capitalize" }}>
                  {activeProducer?.first_name?.toLowerCase()}
                  <> </>
                  {activeProducer?.middle_name?.toLowerCase()}
                  <> </>
                  {activeProducer?.last_name?.toLowerCase()}
                  <> </>
                  {activeProducer?.business_name?.toLowerCase()}
                </Typography>
                {(activeProducer?.producer_city_name || activeProducer?.city) && (
                  <Typography variant="body2" color="GrayText" sx={{ textTransform: "capitalize" }}>
                    {activeProducer?.producer_city_name?.toLowerCase() || activeProducer?.city?.toLowerCase()}
                    <>, </>
                    {activeProducer?.producer_state_abbreviation?.toUpperCase() ||
                      activeProducer?.state_abbreviation?.toUpperCase()}
                  </Typography>
                )}
              </Box>
              {[USER_ROLE_ADMIN, USER_ROLE_AGENT].includes(globalState.user_role) && (
                <Box sx={{ ml: "auto" }} justifyContent="flex-end">
                  <IconButton onClick={handleActiveUserSignoutClick}>
                    <LogoutIcon sx={{ width: "18px", height: "18px" }} />
                  </IconButton>
                </Box>
              )}
            </Stack>
          </>
        )}
      </List>

      <Divider />

      <UserInfo
        myUser={myUser}
        activeAgent={activeAgent}
        handleNavigate={handleNavigate}
        handleLogoutClick={handleLogoutClick}
        pathname={pathname}
      />
    </>
  );
};

export default ExpandedMenuContent;
